import React from 'react';
import { Empty } from 'antd';
import { LanguageInfo, Reason } from 'types';

import StyledTable from '../../organisms/styled-table';
import ListModifier from '../../organisms/list-modifier';
import { useIntl } from '../../../common/config/i18n';

type Props = {
  data: Reason[];
  onClickEdit?: (reason: Reason) => void;
  onClickDelete?: (reason: Reason) => void;
  canWrite: boolean;
  translationLanguages: LanguageInfo[];
};

interface CustomColumnType {
  title: string;
  key: string;
  shouldBeAdmin?: boolean;
  render: (record: Reason) => React.ReactNode;
}

const ReasonTable: React.FC<Props> = ({ data, onClickEdit, onClickDelete, canWrite, translationLanguages }: Props) => {
  const { t } = useIntl();

  const columns: CustomColumnType[] = [
    {
      title: t('table', 'CHART_REASON'),
      key: 'name',
      render: (record: Reason) => record.name,
    },
  ];

  translationLanguages.forEach((lang) => {
    columns.push({
      title: lang.label,
      key: lang.label,
      render: (record: Reason) => {
        const value = record.translations.find((translation) => translation.languageCode === lang.code);
        return value?.name;
      },
    });
  });

  columns.push({
    title: t('table', 'COLUMN_EDIT_DELETE'),
    key: 'modifier',
    shouldBeAdmin: true,
    render: (record: Reason) => {
      return (
        <ListModifier
          hideEditButton={record.isNotEditable || !canWrite}
          hideDeleteButton={record.isNotEditable || !canWrite}
          onDelete={() => onClickDelete?.(record)}
          onEdit={() => onClickEdit?.(record)}
        />
      );
    },
  });

  return (
    <StyledTable
      textAlign="left"
      pagination={false}
      dataSource={data}
      columns={canWrite ? columns : columns.filter((column) => !column.shouldBeAdmin)}
      rowKey="id"
      locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
    />
  );
};

export default ReasonTable;
